import React from 'react';
import './LandingPage.css';

export default function AddPosition() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Position</h1>
      <p>Form/page to add a position (placeholder).</p>
    </main>
  );
}
